// The weight column is a generated column cast to NUMERIC(6, 2) in Postgres so
// this is a hard backend ceiling — anything higher overflows and crashes the
// database write.
export const MAX_PRODUCT_WEIGHT_KG = 9999.99;
/**
 * @deprecated use orderableItems
 */
export const ProductTypes = Object.freeze({
    beverage: {
        display: "Beverage",
        key: "beverage",
        children: {
            bottle: {
                key: "bottle",
                display: "Bottle",
            },
            can: {
                key: "can",
                display: "Can",
            },
            draught: {
                key: "draught",
                display: "Draught item",
                children: {
                    cask: {
                        display: "Cask",
                        key: "cask",
                        children: {
                            keyCask: {
                                key: "keyCask",
                                display: "KeyCask",
                            },
                            eCask: {
                                key: "eCask",
                                display: "eCask",
                            },
                            cask: {
                                key: "cask",
                                display: "Cask",
                            },
                            miniCask: {
                                key: "miniCask",
                                display: "Mini Cask",
                            },
                            polyPin: {
                                key: "polyPin",
                                display: "PolyPin Cask",
                            },
                            flatBottomPin: {
                                key: "flatBottomPin",
                                display: "Flat Bottom Pin",
                            },
                            caskKegstar: {
                                key: "caskKegstar",
                                display: "Cask - Kegstar",
                            },
                            caskBranded: {
                                key: "caskBranded",
                                display: "Cask - Branded",
                            },
                        },
                    },
                    keg: {
                        display: "Keg",
                        key: "keg",
                        children: {
                            sankeyKeg: {
                                key: "sankeyKeg",
                                display: "Sankey Keg",
                                materialType: "steelKeg",
                            },
                            keyKeg: {
                                key: "keyKeg",
                                display: "KeyKeg",
                                materialType: "plasticKeg",
                            },
                            eKeg: {
                                key: "eKeg",
                                display: "E-Keg",
                                materialType: "steelKeg",
                            },
                            americanKeg: {
                                key: "americanKeg",
                                display: "A-type Keg",
                                materialType: "steelKeg",
                            },
                            polyKeg: {
                                key: "polyKeg",
                                display: "PolyKeg",
                                materialType: "plasticKeg",
                            },
                            grundyKeg: {
                                key: "grundyKeg",
                                display: "G-Type Grundy Keg",
                                materialType: "steelKeg",
                            },
                            ecoKeg: {
                                key: "ecoKeg",
                                display: "EcoKeg",
                                materialType: "plasticKeg",
                            },
                            miniKeg: {
                                key: "miniKeg",
                                display: "Mini Keg",
                                materialType: "steelKeg",
                            },
                            sTypeKonvoyKeg: {
                                key: "sTypeKonvoyKeg",
                                display: "S-Type Konvoy Keg",
                                materialType: "steelKeg",
                            },
                            nitroSankeyKeg: {
                                key: "nitroSankeyKeg",
                                display: "Nitro Sankey Keg",
                                materialType: "steelKeg",
                            },
                            nitroKeyKeg: {
                                key: "nitroKeyKeg",
                                display: "Nitro Keykeg",
                                materialType: "plasticKeg",
                            },
                            sTypeKegstar: {
                                key: "sTypeKegstar",
                                display: "S-Type Kegstar",
                                materialType: "steelKeg",
                            },
                            dTypeKeg: {
                                key: "dTypeKeg",
                                display: "D-Type Keg",
                                materialType: "steelKeg",
                            },
                            mTypeKeg: {
                                key: "mTypeKeg",
                                display: "M-Type Keg",
                                materialType: "steelKeg",
                            },
                            corneliusKeg: {
                                key: "corneliusKeg",
                                display: "Cornelius Keg",
                                materialType: "steelKeg",
                            },
                            polyKegBagged: {
                                key: "polyKegBagged",
                                display: "Polykeg - Bagged",
                                materialType: "plasticKeg",
                            },
                            sTypeUniKeg: {
                                key: "sTypeUniKeg",
                                display: "S-Type UniKeg",
                                materialType: "plasticKeg",
                            },
                            sTypeTalosKeg: {
                                key: "sTypeTalosKeg",
                                display: "S-Type Talos Keg",
                                materialType: "plasticKeg",
                            },
                            dTypeUniKeg: {
                                key: "dTypeUniKeg",
                                display: "D-Type UniKeg",
                                materialType: "plasticKeg",
                            },
                            polyKegBaggedKeyKegCoupler: {
                                key: "polyKegBaggedKeyKegCoupler",
                                display: "Polykeg - Bagged - KeyKeg Coupler",
                                materialType: "plasticKeg",
                            },
                            polyKegBaggedSankeyCoupler: {
                                key: "polyKegBaggedSankeyCoupler",
                                display: "Polykeg - Bagged - Sankey Coupler",
                                materialType: "plasticKeg",
                            },
                            polyKegBagless: {
                                key: "polyKegBagless",
                                display: "Polykeg - Bagless",
                                materialType: "plasticKeg",
                            },
                            petainerKeg: {
                                key: "petainerKeg",
                                display: "Petainer Keg",
                                materialType: "plasticKeg",
                            },
                            doliumKeg: {
                                key: "doliumKeg",
                                display: "Dolium Keg",
                                materialType: "plasticKeg",
                            },
                        },
                    },
                },
            },
            pouch: {
                key: "pouch",
                display: "Pouch",
            },
            bagInBox: {
                key: "bagInBox",
                display: "Bag In Box",
            },
            jerryCan: {
                key: "jerryCan",
                display: "Jerry Can",
            },
            box: {
                key: "box",
                display: "Box",
            },
        },
    },
    glassware: {
        key: "glassware",
        display: "Glassware",
        children: {
            glass: {
                display: "Glass",
                key: "glass",
            },
            tuboGlass: {
                display: "Tubo Glass",
                key: "tuboGlass",
            },
        },
    },
    snack: {
        display: "Snack",
        key: "snack",
        children: {
            bag: {
                display: "Bag",
                key: "bag",
            },
            jar: {
                display: "Jar",
                key: "jar",
            },
        },
    },
    misc: {
        display: "Miscellaneous",
        key: "misc",
        children: {},
    },
});
const flatten = (productTypes, path = []) => Object.values(productTypes).flatMap((productType) => {
    return productType?.children
        ? flatten(productType.children, [
            ...path,
            productType.key,
        ])
        : { ...productType, path };
});
export const ProductTypesFlat = flatten(ProductTypes);
//# sourceMappingURL=productCommons.js.map